import React, { createContext, useState } from "react";

export const DateContext = createContext();

export const DateProvider = ({ children }) => {
    const [withinDate, setWithinDate] = useState('past1days');

    return (
        <DateContext.Provider value={{ withinDate, setWithinDate }}>
            {children}
        </DateContext.Provider>
    );
};
